import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
  super.connectedCallback();

  const { videoSources, videoElement } = this.refs;

  for (const source of videoSources) {
    const { videoSource } = source.dataset;
    if (videoSource) source.setAttribute('src', videoSource);
  }

  videoElement.load();

  // Injecte le bouton mute après chargement de la vidéo
  this.injectMuteButton(videoElement);
}

injectMuteButton(video) {
  if (this.querySelector('.video-mute-container')) return;

  const ON_SVG  = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a7 7 0 0 1 0 9.9M19.07 4.93a10 10 0 0 1 0 14.14"></path></svg>`;
  const OFF_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>`;

  this.style.setProperty('position', 'relative', 'important');
  this.style.setProperty('overflow', 'visible', 'important');

  const wrap = document.createElement('div');
  wrap.setAttribute('style',
    'position:absolute!important;bottom:12px!important;right:12px!important;' +
    'z-index:9999!important;display:block!important;pointer-events:auto!important;'
  );

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.setAttribute('style',
    'background:transparent!important;background-color:transparent!important;' +
    'border:none!important;padding:0!important;box-shadow:none!important;' +
    'outline:none!important;cursor:pointer!important;display:flex!important;' +
    'align-items:center!important;justify-content:center!important;'
  );
  btn.innerHTML = video.muted ? OFF_SVG : ON_SVG;

  btn.addEventListener('click', e => {
    e.stopPropagation();
    e.preventDefault();
    video.muted = !video.muted;
    btn.innerHTML = video.muted ? OFF_SVG : ON_SVG;
  });

  video.addEventListener('volumechange', () => {
    btn.innerHTML = video.muted ? OFF_SVG : ON_SVG;
  });

  // SVG style inline
  const svgStyle = document.createElement('style');
  svgStyle.textContent = `
    video-background-component button svg {
      width: 32px !important;
      height: 32px !important;
      filter: drop-shadow(0 2px 4px rgba(0,0,0,0.5)) !important;
      display: block !important;
    }
  `;
  document.head.appendChild(svgStyle);

  wrap.appendChild(btn);
  this.appendChild(wrap);
}

}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
